export default "__VITE_ASSET__DpsNW9cg__"